/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { ADDITIONAL_ROLES_ORG } from '../../../constants/main';

/**
 * Returns true if the user can access the livechat application
 * @param {user} Object User to look priviledges for. If not passed the function will look at the current user
 * @param {orgId} String The current organization id
 * @param {tenantId} String The current tenant id. If null it will look up all available tenants
 * @returns {Boolean} Whether a user has live chat access.
 */
const hasLiveChatAccess = (user, orgId) => {
  const validRoles = [ADDITIONAL_ROLES_ORG.LIVE_AGENT, ADDITIONAL_ROLES_ORG.LIVECHAT_ADMIN];

  if (user) {
    return user.effectiveRoles.organizationRoles?.[orgId]?.some(role => validRoles.includes(role));
  }

  return false;
};

export default hasLiveChatAccess;
